import request from '@/utils/request'

// 操作类型枚举
export const OperationType = {
  LOGIN: 1,      // 登录
  ADD: 2,        // 新增
  UPDATE: 3,     // 修改
  DELETE: 4,     // 删除
  EXPORT: 5      // 导出
}

// 记录操作日志
export function recordOperationLog(operationType, operationContent, detail = {}) {
  return request({
    url: '/admin/log/record',
    method: 'post',
    data: {
      operationType,
      operationContent,
      detail: JSON.stringify(detail)  // 记录详细的操作内容
    }
  })
}

// 记录登录日志
export function recordLoginLog() {
  return recordOperationLog(OperationType.LOGIN, '管理员登录系统', {
    loginTime: new Date().toISOString(),
    userAgent: navigator.userAgent
  })
}

// 记录新增操作
export function recordAddLog(content, detail) {
  return recordOperationLog(OperationType.ADD, content, {
    ...detail,
    operationTime: new Date().toISOString()
  })
}

// 记录修改操作
export function recordUpdateLog(content, oldData, newData) {
  return recordOperationLog(OperationType.UPDATE, content, {
    oldData,
    newData,
    operationTime: new Date().toISOString(),
    changes: getChanges(oldData, newData)
  })
}

// 记录删除操作
export function recordDeleteLog(content, deletedData) {
  return recordOperationLog(OperationType.DELETE, content, {
    deletedData,
    operationTime: new Date().toISOString()
  })
}

// 记录导出操作
export function recordExportLog(content, exportParams) {
  return recordOperationLog(OperationType.EXPORT, content, {
    exportParams,
    operationTime: new Date().toISOString()
  })
}

// 获取数据变化
function getChanges(oldData, newData) {
  const changes = {}
  for (const key in newData) {
    if (oldData[key] !== newData[key]) {
      changes[key] = {
        oldValue: oldData[key],
        newValue: newData[key]
      }
    }
  }
  return changes
} 


// WEBPACK FOOTER //
// ./src/utils/adminLog.js